import { SvgIcon, SvgIconProps } from "@mui/material";

export const DevicemanagementIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M19.841 10.833c0-1.15-2.611-2.083-5.833-2.083s-5.833.932-5.833 2.083v6.334c0 1.15 2.611 2.083 5.833 2.083"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M19.841 11.916c0 1.15-2.611 2.083-5.833 2.083s-5.833-.932-5.833-2.083"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M13.92 24.5H9.333A5.833 5.833 0 0 1 3.5 18.667V9.333A5.833 5.833 0 0 1 9.333 3.5h9.334A5.833 5.833 0 0 1 24.5 9.333v4.83"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="m24.95 21.458-2.022.85c-.278.117-.5.338-.616.616l-.853 2.027a1.167 1.167 0 0 1-2.194-.123l-1.718-5.832a1.167 1.167 0 0 1 1.449-1.448l5.832 1.715a1.167 1.167 0 0 1 .123 2.195Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M19.833 10.83v1.083"
      />
    </svg>
  </SvgIcon>
);
